// extracted by mini-css-extract-plugin
module.exports = {"work":"Work_work__2kXEW","title_open":"Work_title_open__2r41v","title_close":"Work_title_close__5OGYe","landIn":"Work_landIn__RQ4mr"};